module.exports = __webpack_public_path__ + "static/media/understand-yourself.8b9d6975.svg";